import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import BikeTable from '../../components/Bike/BikeTable';
import { BIKE_ADD } from '../../constants/routes';
import { ROLE_USER, ROLE_ADMIN } from '../../constants/roles';
import { getSites } from '../../store/sites/actions';
import { getRenters } from '../../store/renters/actions';
import { getBikes } from '../../store/bikes/actions';

const styles = () => ({
  addButton: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    bottom: '3vh',
    right: '3vh',
    zIndex: 10,
  },
});

export class BikesPage extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  state={
    role: ROLE_USER,
  };

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (
      props.authUser
      && props.roles
      && props.errorRenters === null
      && props.errorSites === null
      && props.errorBikes === null
    ) {
      const role = props.roles[props.authUser.uid];
      newState = { ...newState, role };
      if (!props.bikes && !props.pendingBikes) {
        props.getBikes(props.authUser.ma, role);
      }
      if (!props.renters && !props.pendingRenters) {
        props.getRenters(props.authUser.ma, role);
      }
      if (!props.sites && !props.pendingSites) {
        props.getSites(props.authUser.ma, role);
      }
    }

    if (props.bikes && props.renters) {
      props.bikes.forEach((bike) => {
        bike.renterName = props.renters
          .find(renter => renter.id === bike.renter_info_id).name;
      });
    }
    if (props.bikes && props.sites) {
      props.bikes.forEach((bike) => {
        const bikeSite = props.sites.find(site => site.id === bike.site_id);
        if (bikeSite) {
          bike.siteName = bikeSite.name;
          bike.siteType = bikeSite.type;
        }
      });
    }
    return newState;
  }

  render() {
    return (
      <LargePaper>
        <h1 style={stylesDefault.title}>Vélos</h1>
        {this.state.role === ROLE_ADMIN &&
        <Fab
          className={this.props.classes.addButton}
          color="primary"
          component={Link}
          aria-label="add"
          to={BIKE_ADD}
        >
          <AddIcon/>
        </Fab>
        }
        <BikeTable
          bikes={this.props.bikes ? this.props.bikes : []}
          isInBikePage={true}
          pending={this.props.pending}
        />
      </LargePaper>
    );
  }
}

const authCondition = authUser => !!authUser;

const mapStateToProps = state => ({
  authUser: state.users.authUser,
  roles: state.roles.content,
  pending: state.renters.pending || state.sites.pending || state.bikes.pending,
  renters: state.renters.content,
  sites: state.sites.content,
  bikes: state.bikes.content,
  pendingRenters: state.renters.pending,
  pendingSites: state.sites.pending,
  pendingBikes: state.bikes.pending,
  errorRenters: state.renters.error,
  errorSites: state.sites.error,
  errorBikes: state.bikes.error
});

export default compose(
  withAuthorization(authCondition),
  connect(mapStateToProps, { getRenters, getSites, getBikes }),
  withStyles(styles),
)(BikesPage);



// WEBPACK FOOTER //
// ./src/containers/BikesPage/BikesPage.jsx